import React, { useState } from "react";
import { useAttributes, useFetchedValues } from "../../../Hooks/Display/useComponentProperties";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { ATTRIBUTE_LABEL, ATTRIBUTE_PLURAL_LABEL } from "../../Helpers/Labels/AttributeLabel";
import usePages, { useSelectedPage } from "../../../Hooks/Display/usePages";
import { useTranslation } from "react-i18next";
import { getOptimizedAttributes, getOptimizedFormBuilderAttributes } from "../../../API/Recommendation/DisplayRecommendation";
import InnerLoader from "../../Shared/Loader/InnerLoader";
import { uuidv4 } from "../../../Hooks/Display/utils";

const ComponentAttributeToolbar = ({
    showSelectAttributeButton, showOptimizeAIButton,
    isOptimizeButtonDisabled,
    onRecommend
}) => {

    const [{ pages }] = usePages();
    const [state, dispatch] = useAttributes()
    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const [fetchedValues] = useFetchedValues();
    const componentTypes = selectedComponent.componentType === "View" || selectedComponent.componentType === "Form" ? ["View", "Form"] : ["Table", "Cards", "Calendar", "List", "Kanban", "Summary"]
    const { t } = useTranslation("display/tables/attribute");

    const [loadingRecommendation, setLoadingRecommendation] = useState(false);

    function getNumberOfSyncedComponents() {
        let numComponents = 0;
        for (const pageContainer of pages) {
            for (const page of pageContainer.items) {
                for (const component of page.components) {
                    if (componentTypes.includes(component.componentType) && component.id !== selectedComponent.id) {
                        const checked = selectedComponent.componentsToSync && selectedComponent.componentsToSync.some(
                            ({ componentId, pageId }) => componentId === component.id && pageId === page._id
                        );
                        if (checked) {
                            numComponents++;
                        }
                    }
                }
            }
        }
        return numComponents;
    }

    async function getOptimizedAttributesToShow() {
        try {
            setLoadingRecommendation(true);
            if (selectedComponent.componentType === "Form" || selectedComponent.componentType === "View") {
                debugger;
                const targetAttributes = selectedPage.subPageType === "New Record" ?
                    fetchedValues.attributeTable.attributes.filter(attribute => !attribute.isSystemAttribute) :
                    fetchedValues.attributeTable.attributes;
                const attributes = targetAttributes.map(attribute => ({
                    _id: attribute._id,
                    attributeName: attribute.attributeName,
                    attributeType: attribute.attributeType
                }))
                const componentType = selectedComponent.componentType === "Form" ? "Form" : "Show Details";
                const sections = await getOptimizedFormBuilderAttributes(componentType, attributes);
                const attributesForForm = sections.map(section => ({
                    id: uuidv4(),
                    section: section.sectionName,
                    columns: section.columns
                }))
                onRecommend(attributesForForm);
            } else {
                const allAttributes = fetchedValues.attributeTable.attributes.map(attribute => ({
                    _id: attribute._id,
                    attributeName: attribute.attributeName
                }));
                const attributes = await getOptimizedAttributes(selectedComponent.componentType, allAttributes);
                const attributesForTable = attributes.map(attribute => ({
                    attributeId: attribute.id,
                    hyperlink: false,
                    group: "",
                    tooltip: false,
                    cellRules: false,
                    targetPageId: ""
                }));
                onRecommend(attributesForTable);
            }
        } catch (error) {
            //
        } finally {
            setLoadingRecommendation(false);
        }
    }

    return (
        <div className="d-flex justify-content-between align-items-center p-2 py-3 font-size-1 font-weight-2">

            <div>
                {showSelectAttributeButton &&
                    <>
                        {t("header.title")}
                        <button
                            type="button"
                            className="ms-4 btn btn-secondary"
                            onClick={dispatch.toggleSelectAttributeDialog}
                            disabled={selectedComponent.hidden}
                        >
                            <i className="me-2 fas fa-hand-pointer"></i>{t("header.select_attributes_button")}
                        </button>
                    </>
                }
            </div>
            <div>
                {
                    loadingRecommendation &&
                    <InnerLoader borderColor="green" />
                }
                {
                    showOptimizeAIButton &&
                    <button className="btn btn-outline-primary me-2" onClick={getOptimizedAttributesToShow} disabled={isOptimizeButtonDisabled}>
                        {t("header.ai_optimization_button")}
                    </button>
                }
                <button className="btn btn-secondary" onClick={dispatch.toggleSyncAttributeDialog}>
                    {t("header.sync_components", { count: getNumberOfSyncedComponents() })}
                </button>
            </div>
        </div>
    )
}

export default ComponentAttributeToolbar